export default {
    url: '/average_mission',
    template: require('./view.html'),
    data: {
        title: 'Average Mission',
        priority: 898,
    },
    reloadOnSearch: false,
};
